/* eslint-disable react/no-unescaped-entities */
import { Link } from "react-router-dom";
import { LegalPage, Section, BulletList } from "../components/LegalPage";

export default function Terms() {
  return (
    <LegalPage
      title="Terms & Conditions"
      updated="26 February 2026"
      intro="These Terms govern your use of ShouldIBuyIt.co.uk. By using the website you accept these Terms in full. If you do not accept them, please do not use the site."
    >
      <Section title="1. About us">
        <p>
          ShouldIBuyIt.co.uk is an AI-powered shopping-recommendation website operated from the United Kingdom.
          Contact: <a className="text-emerald-500 underline" href="mailto:hello@shouldibuyit.co.uk">hello@shouldibuyit.co.uk</a>.
        </p>
      </Section>

      <Section title="2. Use of the website">
        <BulletList items={[
          "The website is provided free of charge for personal, non-commercial use.",
          "You must be at least 18 years old to use the recommendation service.",
          "You agree not to use the website for any unlawful, abusive, fraudulent or harmful purpose.",
          "You agree not to scrape, mirror, automate or otherwise systematically extract content beyond ordinary personal use.",
          "We may suspend or restrict access at any time, without notice, where we reasonably believe these Terms have been breached.",
        ]} />
      </Section>

      <Section title="3. Recommendations are guidance, not advice">
        <p>
          The recommendations produced by the Site are generated by an artificial-intelligence model. They are
          intended as buying <em>guidance</em>. We make no warranty that any recommendation is suitable for your
          specific circumstances, that the product is the best choice for you, or that any pricing,
          specification, availability or rating information shown remains accurate at the time you act on it.
        </p>
        <p>
          Recommendations are not professional advice. Where a purchase has legal, financial, medical, safety or
          professional consequences (for example, for accessibility, dietary, child-safety or health products),
          you should consult a qualified professional before making the purchase.
        </p>
        <p>
          See also the <Link to="/ai-disclaimer" className="text-emerald-500 underline">AI Disclaimer</Link>.
        </p>
      </Section>

      <Section title="4. Prices, availability and product information">
        <BulletList items={[
          "Prices displayed on the Site are estimates only. The live price on Amazon may differ.",
          "Product availability, specifications and the identity of an Amazon listing can change at any time. Always confirm the listing on Amazon before completing a purchase.",
          "We are not a seller. Your contract for any product you buy is with Amazon (or the relevant retailer), not with us.",
        ]} />
      </Section>

      <Section title="5. Affiliate relationships">
        <p>
          We participate in the Amazon EU Associates Programme. When you click a Find/Buy on Amazon button and
          complete a qualifying purchase, we may earn a commission at no additional cost to you. The existence
          of an affiliate relationship does not influence which products the AI recommends. See the dedicated{" "}
          <Link to="/affiliate-disclosure" className="text-emerald-500 underline">Affiliate Disclosure</Link>.
        </p>
      </Section>

      <Section title="6. Intellectual property">
        <BulletList items={[
          "All site content, branding, code, copy and design (excluding third-party product names, logos and images displayed for informational purposes) is owned by or licensed to ShouldIBuyIt.co.uk.",
          "Product names, brand names, trade marks and product images are the property of their respective owners and are used for the limited purpose of identifying the items being recommended.",
          "You may share links to specific recommendation pages but may not reproduce significant portions of the site without our written permission.",
        ]} />
      </Section>

      <Section title="7. User-submitted content">
        <p>
          By submitting a query, vote or feedback you grant us a non-exclusive, royalty-free, worldwide licence
          to use that content in anonymised and aggregated form to operate and improve the service. Do not
          submit content that is unlawful, defamatory, obscene, infringing or that contains personal data about
          another individual.
        </p>
      </Section>

      <Section title="8. Limitation of liability">
        <p>
          To the maximum extent permitted by law, we exclude all implied conditions, warranties and other terms.
          We will not be liable for any loss of profit, loss of business, business interruption, loss of
          opportunity, or any indirect or consequential loss arising from your use of the Site or your reliance
          on any recommendation. Nothing in these Terms limits or excludes our liability for death or personal
          injury caused by negligence, fraud or fraudulent misrepresentation, or any liability that cannot be
          excluded under UK law.
        </p>
      </Section>

      <Section title="9. Third-party links">
        <p>
          The Site links to Amazon and other third-party sites. We have no control over the content, products or
          policies of those sites and accept no responsibility for them. You access them at your own risk.
        </p>
      </Section>

      <Section title="10. Privacy">
        <p>
          Our handling of personal data is described in the{" "}
          <Link to="/privacy" className="text-emerald-500 underline">Privacy Policy</Link> and{" "}
          <Link to="/cookies" className="text-emerald-500 underline">Cookie Policy</Link>, which form part of
          these Terms.
        </p>
      </Section>

      <Section title="11. Changes">
        <p>
          We may amend these Terms from time to time. The "Last updated" date at the top of this page reflects
          the most recent change. Continued use of the Site after a change constitutes acceptance of the revised
          Terms.
        </p>
      </Section>

      <Section title="12. Governing law and jurisdiction">
        <p>
          These Terms and any dispute or claim arising out of or in connection with them are governed by the
          laws of England and Wales. The courts of England and Wales have exclusive jurisdiction, save that we
          retain the right to bring proceedings against you in your country of residence or any other relevant
          jurisdiction.
        </p>
      </Section>
    </LegalPage>
  );
}
